import { Box, Heading, Text } from "@chakra-ui/react"
import { useTranslate } from "Shared/hooks/translations/useTranslate"
import { useModeratedStudyApplicationContext } from "UsabilityHub/views/applications/ModeratedStudyApplicationContext"
import {
  centsToDollars,
  creditsToCents,
  formatDollars,
} from "Utilities/currency"
import React from "react"
import { PanelistPostApplicationActions } from "../PanelistPostApplicationActions"
import { PanelistProfileCompletionAlert } from "../PanelistProfileCompletionAlert"

export function ModeratedStudyApplicationEndPage() {
  const t = useTranslate()
  const { application: moderatedStudyApplication } =
    useModeratedStudyApplicationContext()

  return (
    <Box display="flex" maxW="500px" flexDirection="column" gap="4">
      <Heading fontSize="2xl" fontWeight="400">
        {moderatedStudyApplication.panelist
          ? t("interview.application_confirmed.title_panelist")
          : t("interview.application_confirmed.title")}
      </Heading>
      <Text>
        {moderatedStudyApplication.panelist
          ? t("interview.application_confirmed.subtitle_panelist", {
              incentive: formatDollars(
                centsToDollars(
                  creditsToCents(
                    moderatedStudyApplication.panelist.incentive_credits
                  )
                )
              ),
            })
          : t("interview.application_confirmed.subtitle")}
      </Text>

      {moderatedStudyApplication.panelist ? (
        <>
          <PanelistPostApplicationActions mt={6} />
          <PanelistProfileCompletionAlert
            pos={["static", null, null, "absolute"]}
            maxW={[null, null, null, "500px"]}
            bottom={[null, null, null, 10]}
            mt={[6, null, null, 0]}
          />
        </>
      ) : null}
    </Box>
  )
}
